import type { TrackedCaseStatuses } from '#entities/Case';
import { ENOPCaseStatus, ENOPRoutePlanningStatus } from '#entities/enums';

import type { UrgencyBand } from '../model/types';

export const URGENCY_BAND_ORDER: readonly UrgencyBand[] = [
  'highest',
  'high',
  'normal',
  'lowest',
];

const BAND_BY_ACTIVE_STATUS: Record<TrackedCaseStatuses, UrgencyBand> = {
  [ENOPCaseStatus.OrganOnOCS]: 'highest',
  [ENOPCaseStatus.DeployedToTXCenter]: 'highest',
  [ENOPCaseStatus.AtTXCenter]: 'highest',
  [ENOPCaseStatus.ResourceDeployed]: 'high',
  [ENOPCaseStatus.AtDonorHospital]: 'high',
  [ENOPCaseStatus.ResourcesBooked]: 'normal',
  [ENOPCaseStatus.OrganOffOCS]: 'normal',
  [ENOPCaseStatus.ServiceCompleted]: 'normal',
  [ENOPCaseStatus.ReturningToBase]: 'lowest',
  [ENOPCaseStatus.ServiceDeclined]: 'lowest',
};

const BAND_BY_STATUS: Partial<Record<ENOPCaseStatus, UrgencyBand>> =
  BAND_BY_ACTIVE_STATUS;

const PENDING_APPROVALS: ReadonlySet<ENOPRoutePlanningStatus> = new Set([
  ENOPRoutePlanningStatus.WaitingForAviationApproval,
  ENOPRoutePlanningStatus.WaitingForQuoteApproval,
]);

/** A status outside the active set has no band of its own and ranks as planning. */
export const urgencyBand = (
  status: ENOPCaseStatus,
  routePlanningStatus: ENOPRoutePlanningStatus | null,
): UrgencyBand => {
  if (
    status === ENOPCaseStatus.ResourcesBooked &&
    routePlanningStatus !== null &&
    PENDING_APPROVALS.has(routePlanningStatus)
  ) {
    return 'high';
  }
  return BAND_BY_STATUS[status] ?? 'normal';
};
